/**
 * The shapes a box element can take. Rectangles and ellipses are plain CSS (border
 * and radius); the others are an SVG stretched over the box, outline in pt whatever
 * the stretch. Mirror of voucher-backend/src/utils/voucher_html/shapes.py; keep the
 * two identical.
 */
export type BoxShape = 'rect' | 'ellipse' | 'triangle' | 'diamond' | 'star' | 'line';

export const SVG_SHAPES: ReadonlySet<BoxShape> = new Set(['triangle', 'diamond', 'star', 'line']);

function starPoints(): string {
  const points: string[] = [];
  for (let i = 0; i < 10; i++) {
    const radius = i % 2 === 0 ? 50 : 20;
    const angle = (Math.PI / 5) * i - Math.PI / 2;
    points.push(
      `${(50 + radius * Math.cos(angle)).toFixed(2)},${(52 + radius * Math.sin(angle)).toFixed(2)}`,
    );
  }
  return points.join(' ');
}

export const POLYGONS: Record<string, string> = {
  triangle: '50,0 100,100 0,100',
  diamond: '50,0 100,50 50,100 0,50',
  star: starPoints(),
};

/** The palette and inspector entries, in the order they are offered. */
export const SHAPE_CHOICES: { value: BoxShape; label: string; icon: string }[] = [
  { value: 'rect', label: 'Rechteck', icon: 'lucideSquare' },
  { value: 'ellipse', label: 'Ellipse', icon: 'lucideCircle' },
  { value: 'triangle', label: 'Dreieck', icon: 'lucideTriangle' },
  { value: 'diamond', label: 'Raute', icon: 'lucideDiamond' },
  { value: 'star', label: 'Stern', icon: 'lucideStar' },
  { value: 'line', label: 'Linie', icon: 'lucideMinus' },
];
